import {
  type AngelouCSS,
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";
const { mediaQuery } = mediaQueryStyles;

const rootCss = ({ hideTable }: { hideTable: boolean }): AngelouCSS => [
  typographyStyles.textS,
  {
    width: "100%",
    color: constants.colors.ui.neutral[600],
    table: {
      width: "100%",
      display: hideTable ? "none" : "table",
    },
    th: [
      typographyStyles.heading5,
      {
        fontWeight: "bold",
        maxWidth: "250px",
        padding: "16px",
        textAlign: "left",
        "& > button": {
          textAlign: "inherit",
          fontWeight: "inherit",
        },
      },
    ],
    td: {
      padding: "16px",
      textAlign: "left",
    },
  },
];

const TableControlPanelCss = ({
  hasFilterButton,
}: {
  hasFilterButton: boolean;
}): AngelouCSS => ({
  title: {
    visibility: "hidden",
    height: "0",
    overflow: "hidden",
  },
  filterContainer: {
    margin: "0",
  },
  globalFilterContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: hasFilterButton ? "space-between" : "flex-start",
    [mediaQuery.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      flexFlow: "column",
    },
  },
  columnFilterContainer: {
    display: "none",
  },
});

const TablePaginationCss = ({
  hideTable,
}: {
  hideTable: boolean;
}): AngelouCSS => ({
  root: {
    display: hideTable ? "none" : "flex",
    flexFlow: "row-reverse",
    padding: ".75rem",
  },
  PaginationSelect: {
    root: {
      display: "none",
    },
  },
});

const tableContainerCss = ({ hideTable }: { hideTable: boolean }) => ({
  "::after": {
    display: hideTable ? "none" : "block",
  },
});

export const directoryTableCss = ({
  hasFilterButton,
  hideTable,
}: {
  hideTable: boolean;
  hasFilterButton: boolean;
}) => ({
  root: rootCss({ hideTable }),
  tableContainer: tableContainerCss({ hideTable }),
  TableControlPanel: TableControlPanelCss({ hasFilterButton }),
  TablePagination: TablePaginationCss({ hideTable }),
});

export const totalResultsWrapperCss = {
  display: "flex",
  alignItems: "center",
  gap: 8,
};

export const totalResultsStringCss = [
  {
    color: constants.colors.ui.neutral[500],
    fontWeight: "bold",
  },
  typographyStyles.textS,
];

export const filterAndDownloadCss: AngelouCSS = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 16,
};
